import { Loading, Wrapper } from '@wfp/react';
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { connect, useDispatch, useSelector } from 'react-redux';

import NoAccess from 'src/components/NoAccess';
import UsersManagementTemplate from 'src/components/UsersManagementTemplate';
import { requestAPI } from 'src/redux/data/actions';
import { GET_APP_CONFIGURATION } from 'src/redux/view/constants';

export const UsersManagementComponent = () => {
  const dispatch = useDispatch();
  const appConfig = useSelector(
    state => state.viewData?.GET_APP_CONFIGURATION?.data,
  );
  const appConfigFetching = useSelector(
    state => state.viewData?.GET_APP_CONFIGURATION?.isFetching,
  );

  useEffect(() => {
    if (!appConfig) {
      dispatch(requestAPI(GET_APP_CONFIGURATION));
    }
  }, [dispatch, appConfig]);

  if (appConfigFetching || !appConfig) {
    return <Loading withOverlay={true} className="page-loader" />;
  }

  const hasPermissions = appConfig?.userInfo?.hasUserManagementPermission;
  if (!hasPermissions) {
    return <NoAccess variant="role" />;
  }

  return (
    <>
      <Helmet>
        <title>Users Management</title>
      </Helmet>

      <Wrapper pageWidth="lg" spacing="md">
        <UsersManagementTemplate />
      </Wrapper>
    </>
  );
};

export const mapStateToProps = state => {
  return { routesConfig: state.routesConfig };
};

const UsersManagement = connect(mapStateToProps)(UsersManagementComponent);

export default UsersManagement;
